export function useBlogCategory(sectionId: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.find(x => x.sectionId === sectionId)
}
export function useBlogSection(value: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.find(x => x.value === value)
}
export function useArticleProductFamily(slug: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.find(x => x.section === slug)?.productFamily
}
export function useArticleProduct(slug: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.find(x => x.section === slug)?.product
}
export function useBlogSessionsByCategory(category: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.filter(x => x.category === category)?.map(x => x.value).join(',')
}
export function useSectionIds(category: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.filter(categoryItem => categoryItem.category === category)?.map(categoryItem => categoryItem.sectionId).join(',')
}
export function useBlogCategoryFallback(category: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.find(x => x.value === category)
}
export function useArticleProductFamilyFallback(value: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.find(x => x.value === value)?.productFamily
}
export function useArticleProductFallback(category: string, blogCategories: Array<StoryBlokBlogCategory>) {
  return blogCategories.find(x => x.value === category)?.product
}

// blog and adviser shared helpers
export function fbShare() {
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
    'facebook-share-dialog',
    'width=800,height=600',
  )
  return false
}
export function twShare() {
  window.open(`https://twitter.com/share?url=${window.location.href}`,
    'twitter-share-dialog',
    'width=800,height=600',
  )
  return false
}
